import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';
import PropTypes from 'prop-types';

import { FocusGrid, InfoContainerGrid } from '#client/components/Grid';

import { WrapperStyle } from '../TransactionDetailModal.style';

const WrapperStyled = styled(Box)(WrapperStyle);

export default function DetailWrapper({ children }) {
  return (
    <InfoContainerGrid paddingBottom={{ xs: '150px', md: '40px' }}>
      <FocusGrid>
        <WrapperStyled>
          <Box paddingTop={{ xs: '32px', md: '64px' }}>{children}</Box>
        </WrapperStyled>
      </FocusGrid>
    </InfoContainerGrid>
  );
}

DetailWrapper.propTypes = {
  children: PropTypes.node.isRequired
};
